/**
 * Do not edit directly
 * Generated on Wed, 19 Jun 2024 15:24:56 GMT
 */

export const AssetAppIconDefault = "app/icon/icon.png";
export const AssetAppIconDefaultWhite = "app/icon/icon-white.png";
export const AssetAppIconForeground = "app/icon/icon-foreground.png";
export const AssetAppIconRound = "app/icon/icon-round.png";
export const AssetAppIconRoundWhite = "app/icon/icon-white-round.png";
export const AssetAppSplash = "app/splash/splash.png";
export const AssetAppSplashWhite = "app/splash/splash-white.png";
export const AssetAvatarsAvatarAw = "images/avatars/avatar-aw.svg";
export const AssetAvatarsAvatarAwStar = "images/avatars/avatar-aw-star.svg";
export const AssetAvatarsAvatarGrey = "images/avatars/avatar-grey.svg";
export const AssetAvatarsAvatarNew = "images/avatars/avatar-new.svg";
export const AssetAvatarsAvatarStar = "images/avatars/avatar-star.svg";
export const AssetComplimentsAboveBeyond = "images/compliments/above-beyond.svg";
export const AssetComplimentsBestCleaner = "images/compliments/best-cleaner.svg";
export const AssetComplimentsCleaning = "images/compliments/cleaning.svg";
export const AssetComplimentsEfficiency = "images/compliments/efficiency.svg";
export const AssetComplimentsMadeDay = "images/compliments/made-day.svg";
export const AssetComplimentsPetFriendly = "images/compliments/pet-friendly.svg";
export const AssetComplimentsPoliteness = "images/compliments/politeness.svg";
export const AssetComplimentsRightOnTime = "images/compliments/right-on-time.svg";
export const AssetComplimentsService = "images/compliments/service.svg";
export const AssetComplimentsThoroughness = "images/compliments/thoroughness.svg";
export const AssetComplimentsTidying = "images/compliments/tidying.svg";
export const AssetIconArrowCurvedRight = "icons/arrow-curved-right.svg";
export const AssetIconBin = "icons/bin.svg";
export const AssetIconBlinds = "icons/blinds.svg";
export const AssetIconBoiler = "icons/boiler.svg";
export const AssetIconBookmark = "icons/bookmark.svg";
export const AssetIconBuildings = "icons/buildings.svg";
export const AssetIconCalendarBlank = "icons/calendar-blank.svg";
export const AssetIconCalendarClock = "icons/calendar-clock.svg";
export const AssetIconCalendarFull = "icons/calendar-full.svg";
export const AssetIconCalendarHalf = "icons/calendar-half.svg";
export const AssetIconCalendarRecurring = "icons/calendar-recurring.svg";
export const AssetIconCar = "icons/car.svg";
export const AssetIconCardboardBox = "icons/cardboard-box.svg";
export const AssetIconCarpetRolled = "icons/carpet-rolled.svg";
export const AssetIconCat = "icons/cat.svg";
export const AssetIconChat = "icons/chat.svg";
export const AssetIconChatDouble = "icons/chat-double.svg";
export const AssetIconChatEn = "icons/chat-en.svg";
export const AssetIconChemical = "icons/chemical.svg";
export const AssetIconChristmasTree = "icons/christmas-tree.svg";
export const AssetIconChristmasTreeUnlit = "icons/christmas-tree-unlit.svg";
export const AssetIconCircle = "icons/circle.svg";
export const AssetIconClock = "icons/clock.svg";
export const AssetIconClockAlt = "icons/clock-alt.svg";
export const AssetIconClockShield = "icons/clock-shield.svg";
export const AssetIconCog = "icons/cog.svg";
export const AssetIconCoins = "icons/coins.svg";
export const AssetIconConcierge = "icons/concierge.svg";
export const AssetIconCongestionCharge = "icons/congestion-charge.svg";
export const AssetIconCross = "icons/cross.svg";
export const AssetIconCrossCircle = "icons/cross-circle.svg";
export const AssetIconCupboard = "icons/cupboard.svg";
export const AssetIconCurtains = "icons/curtains.svg";
export const AssetIconDocument = "icons/document.svg";
export const AssetIconDocumentStack = "icons/document-stack.svg";
export const AssetIconDocumentTicks = "icons/document-ticks.svg";
export const AssetIconDog = "icons/dog.svg";
export const AssetIconDrainExternal = "icons/drain-external.svg";
export const AssetIconEllipsisCircle = "icons/ellipsis-circle.svg";
export const AssetIconEnvelope = "icons/envelope.svg";
export const AssetIconEnvelopeOpen = "icons/envelope-open.svg";
export const AssetIconEnvelopeTickCircle = "icons/envelope-tick-circle.svg";
export const AssetIconExclamationMarkCircle = "icons/exclamation-mark-circle.svg";
export const AssetIconFaceHappy = "icons/face-happy.svg";
export const AssetIconFaceNeutral = "icons/face-neutral.svg";
export const AssetIconFaceSad = "icons/face-sad.svg";
export const AssetIconFireExtinguisher = "icons/fire-extinguisher.svg";
export const AssetIconFire = "icons/fire.svg";
export const AssetIconFlag = "icons/flag.svg";
export const AssetIconFridge = "icons/fridge.svg";
export const AssetIconGlobe = "icons/globe.svg";
export const AssetIconGloves = "icons/gloves.svg";
export const AssetIconHardHat = "icons/hard-hat.svg";
export const AssetIconHeart = "icons/heart.svg";
export const AssetIconHourglass = "icons/hourglass.svg";
export const AssetIconHouse = "icons/house.svg";
export const AssetIconHouseStack = "icons/house-stack.svg";
export const AssetIconHousehold = "icons/household.svg";
export const AssetIconIdCard = "icons/id-card.svg";
export const AssetIconInfoCircle = "icons/info-circle.svg";
export const AssetIconInsight = "icons/insight.svg";
export const AssetIconIron = "icons/iron.svg";
export const AssetIconIroningBoard = "icons/ironing-board.svg";
export const AssetIconKey = "icons/key.svg";
export const AssetIconKeyHand = "icons/key-hand.svg";
export const AssetIconLawnMower = "icons/lawn-mower.svg";
export const AssetIconLeafDouble = "icons/leaf-double.svg";
export const AssetIconLeakyPipe = "icons/leaky-pipe.svg";
export const AssetIconLightBulb = "icons/light-bulb.svg";
export const AssetIconLocationPin = "icons/location-pin.svg";
export const AssetIconLogout = "icons/logout.svg";
export const AssetIconMattress = "icons/mattress.svg";
export const AssetIconMedicalCrossCircle = "icons/medical-cross-circle.svg";
export const AssetIconMedicalCrossSquare = "icons/medical-cross-square.svg";
export const AssetIconMegaphone = "icons/megaphone.svg";
export const AssetIconMission = "icons/mission.svg";
export const AssetIconMoneyNotes = "icons/money-notes.svg";
export const AssetIconMopBucket = "icons/mop-bucket.svg";
export const AssetIconMortarboard = "icons/mortarboard.svg";
export const AssetIconNavigationArrow = "icons/navigation-arrow.svg";
export const AssetIconOven = "icons/oven.svg";
export const AssetIconPadlock = "icons/padlock.svg";
export const AssetIconPadlockOpen = "icons/padlock-open.svg";
export const AssetIconPaintRoller = "icons/paint-roller.svg";
export const AssetIconPartyPopper = "icons/party-popper.svg";
export const AssetIconPaw = "icons/paw.svg";
export const AssetIconPaymentCard = "icons/payment-card.svg";
export const AssetIconPencil = "icons/pencil.svg";
export const AssetIconPeopleStacked = "icons/people-stacked.svg";
export const AssetIconPerson = "icons/person.svg";
export const AssetIconPersonArrow = "icons/person-arrow.svg";
export const AssetIconPersonRunning = "icons/person-running.svg";
export const AssetIconPhone = "icons/phone.svg";
export const AssetIconPipe = "icons/pipe.svg";
export const AssetIconPlunger = "icons/plunger.svg";
export const AssetIconPlus = "icons/plus.svg";
export const AssetIconPresent = "icons/present.svg";
export const AssetIconQuestionMarkCircle = "icons/question-mark-circle.svg";
export const AssetIconRadiator = "icons/radiator.svg";
export const AssetIconRemovalVan = "icons/removal-van.svg";
export const AssetIconRosette = "icons/rosette.svg";
export const AssetIconRubbishBag = "icons/rubbish-bag.svg";
export const AssetIconSaw = "icons/saw.svg";
export const AssetIconShare = "icons/share.svg";
export const AssetIconShovel = "icons/shovel.svg";
export const AssetIconSofa = "icons/sofa.svg";
export const AssetIconSponge = "icons/sponge.svg";
export const AssetIconSpongeAlt = "icons/sponge-alt.svg";
export const AssetIconSprayBottle = "icons/spray-bottle.svg";
export const AssetIconSquare = "icons/square.svg";
export const AssetIconSquareStack = "icons/square-stack.svg";
export const AssetIconStar = "icons/star.svg";
export const AssetIconStarFill = "icons/star-fill.svg";
export const AssetIconSteamer = "icons/steamer.svg";
export const AssetIconStorageShelves = "icons/storage-shelves.svg";
export const AssetIconSupport = "icons/support.svg";
export const AssetIconTechnology = "icons/technology.svg";
export const AssetIconThumbsDown = "icons/thumbs-down.svg";
export const AssetIconThumbsUp = "icons/thumbs-up.svg";
export const AssetIconTick = "icons/tick.svg";
export const AssetIconTickCircle = "icons/tick-circle.svg";
export const AssetIconTickShield = "icons/tick-shield.svg";
export const AssetIconTickSquare = "icons/tick-square.svg";
export const AssetIconTimer = "icons/timer.svg";
export const AssetIconVacuum = "icons/vacuum.svg";
export const AssetIconWashingMachine = "icons/washing-machine.svg";
export const AssetIconWindow = "icons/window.svg";
export const AssetIconWrench = "icons/wrench.svg";
export const AssetHousekeeperCleaningWoman = "images/housekeepers/cleaning-woman.svg";
export const AssetHousekeeperCrinkleDecreaser = "images/housekeepers/crinkle-decreaser.svg";
export const AssetHousekeeperCrumbHooverer = "images/housekeepers/crumb-hooverer.svg";
export const AssetHousekeeperDeskCleaner = "images/housekeepers/desk-cleaner.svg";
export const AssetHousekeeperDustBuster = "images/housekeepers/dust-buster.svg";
export const AssetHousekeeperGardener = "images/housekeepers/gardener.svg";
export const AssetHousekeeperHandsInPockets = "images/housekeepers/hands-in-pockets.svg";
export const AssetHousekeeperHandsInPocketsSad = "images/housekeepers/hands-in-pockets-sad.svg";
export const AssetHousekeeperHighReacher = "images/housekeepers/high-reacher.svg";
export const AssetHousekeeperHousekeeperStockFourImages = "images/housekeepers/housekeeper-stock-four-images.svg";
export const AssetHousekeeperMopPlungerMan = "images/housekeepers/mop-plunger-man.svg";
export const AssetHousekeeperMopPlungerMaskedMan = "images/housekeepers/mop-plunger-masked-man.svg";
export const AssetHousekeeperMopPlungerMaskedWoman = "images/housekeepers/mop-plunger-masked-woman.svg";
export const AssetHousekeeperMopPlungerWoman = "images/housekeepers/mop-plunger-woman.svg";
export const AssetHousekeeperMopSwisher = "images/housekeepers/mop-swisher.svg";
export const AssetHousekeeperPictureDewonker = "images/housekeepers/picture-dewonker.svg";
export const AssetHousekeeperSheetShaker = "images/housekeepers/sheet-shaker.svg";
export const AssetHousekeeperThumbsUpMan = "images/housekeepers/thumbs-up-man.svg";
export const AssetHousekeeperThumbsUpWoman = "images/housekeepers/thumbs-up-woman.svg";
export const AssetHousekeeperTradespersonWrench = "images/housekeepers/tradesperson-wrench.svg";
export const AssetHousekeeperTrashFlinger = "images/housekeepers/trash-flinger.svg";
export const AssetHousekeeperUnsure = "images/housekeepers/unsure.svg";
export const AssetHousekeeperWindowWasher = "images/housekeepers/window-washer.svg";
export const AssetHousekeepSymbolBlack = "logo/symbol/housekeep-symbol-black.svg";
export const AssetHousekeepSymbolBlue = "logo/symbol/housekeep-symbol-blue.svg";
export const AssetHousekeepSymbolBrightGreen = "logo/symbol/housekeep-symbol-bright-green.svg";
export const AssetHousekeepSymbolWhite = "logo/symbol/housekeep-symbol-white.svg";
export const AssetHousekeepWordmarkBlack = "logo/wordmark/housekeep-wordmark-black.svg";
export const AssetHousekeepWordmarkBlue = "logo/wordmark/housekeep-wordmark-blue.svg";
export const AssetHousekeepWordmarkBrightGreen = "logo/wordmark/housekeep-wordmark-bright-green.svg";
export const AssetHousekeepWordmarkWhite = "logo/wordmark/housekeep-wordmark-white.svg";
export const AssetMiscGift = "images/misc/gift.svg";
export const AssetMiscGiftDisabled = "images/misc/gift-disabled.svg";
export const AssetMiscPaymentCard = "images/misc/payment-card.svg";
export const AssetMiscTickCircle = "images/misc/tick-circle.svg";
export const AssetTasksDeepClean = "images/tasks/deep-clean.svg";
export const AssetTasksFridge = "images/tasks/fridge.svg";
export const AssetTasksIroning = "images/tasks/ironing.svg";
export const AssetTasksLaundry = "images/tasks/laundry.svg";
export const AssetTasksOven = "images/tasks/oven.svg";
export const AssetTasksRegularClean = "images/tasks/regular-clean.svg";
export const AssetTasksTradesperson = "images/tasks/tradesperson.svg";
export const AssetTasksWindowsInside = "images/tasks/windows-inside.svg";
export const AssetTasksWindowsOutside = "images/tasks/windows-outside.svg";
export const BorderRadiusSmall = "4px";
export const BorderRadiusMedium = "5px";
export const BorderRadiusLarge = "6px";
export const BorderRadiusFormControlSmall = "4px";
export const BorderRadiusFormControlMedium = "5px";
export const BorderRadiusFormControlLarge = "6px";
export const BorderRadiusButtonSmall = "4px";
export const BorderRadiusButtonMedium = "5px";
export const BorderRadiusButtonLarge = "6px";
export const BorderRadiusCard = "6px";
export const BorderRadiusCheckbox = "2px";
export const BorderWidthDefault = "1px";
export const BorderWidthButton = "1px";
export const BorderWidthButtonSpinner = "2px";
export const BorderWidthCard = "1px";
export const BorderWidthCheckbox = "1px";
export const BorderWidthFormControl = "1px";
export const BorderWidthRadio = "1px";
export const BorderColorButtonDefaultOutline = "#ced7db";
export const BorderColorButtonPrimaryOutline = "#3040b6";
export const BorderColorButtonSecondaryOutline = "#00fffc";
export const BorderColorButtonSuccessOutline = "#00be5f";
export const BorderColorButtonWarningOutline = "#ff9500";
export const BorderColorButtonDangerOutline = "#ff002d";
export const BorderColorButtonWhiteOutline = "#ffffff";
export const BorderColorCardDefault = "#e6ebed";
export const BorderColorCardPrimary = "#3040b6";
export const BorderColorFormControlDefault = "#ced7db";
export const BorderColorFormControlFocus = "#3040b6";
export const BorderColorFormControlInvalid = "#ff002d";
export const BorderColorFormControlDisabled = "#f3f5f7";
export const BorderColorRadioDefault = "#3040b6";
export const BorderColorRadioInvalid = "#ff002d";
export const BorderColorRadioDisabled = "#e6ebed";
export const BorderColorCheckboxDefault = "#3040b6";
export const BorderColorCheckboxInvalid = "#ff002d";
export const BorderColorCheckboxDisabled = "#f3f5f7";
export const BoxShadowButton = "2px";
export const BreakpointMinXs = "360px"; // Extra-Small min-width breakpoint for mobile
export const BreakpointMinSm = "480px"; // Small min-width breakpoint for mobile (landscape)
export const BreakpointMinMd = "768px"; // Medium min-width breakpoint for tablet (portrait)
export const BreakpointMinLg = "992px"; // Large min-width breakpoint for desktop and tablet (landscape)
export const BreakpointMinXl = "1280px"; // Extra-Large min-width breakpoint for wide-screens
export const BreakpointMaxXxs = "359px"; // XX-Small max-width breakpoint for very small mobile (less than 360px)
export const BreakpointMaxXs = "479px"; // Extra-Small max-width breakpoint for upto mobile (landscape)
export const BreakpointMaxSm = "767px"; // Small max-width breakpoint for upto tablet (portrait)
export const BreakpointMaxMd = "991px"; // Medium max-width breakpoint for upto desktop and tablet (landscape)
export const BreakpointMaxLg = "1279px"; // Large max-width breakpoint for upto wide-screens
export const BreakpointGridSm = "480px";
export const BreakpointGridMd = "768px";
export const BreakpointGridLg = "992px";
export const BreakpointGridXl = "1280px";
export const ColorBrandBlue25 = "#f8fbfe";
export const ColorBrandBlue50 = "#eaecf8"; // 10% of blue for background tint
export const ColorBrandBlue100 = "#d7daf1";
export const ColorBrandBlue200 = "#adb3e2";
export const ColorBrandBlue300 = "#848ed4";
export const ColorBrandBlue400 = "#5966c5";
export const ColorBrandBlue500 = "#3040b6";
export const ColorBrandBlue600 = "#273493";
export const ColorBrandBlue700 = "#1d276e";
export const ColorBrandBlue800 = "#141a4a";
export const ColorBrandBlue900 = "#0a0d25";
export const ColorBrandBrightGreen75 = "#edffff"; // 15% of bright-green for background tint
export const ColorBrandBrightGreen100 = "#cdffff";
export const ColorBrandBrightGreen200 = "#99fffe";
export const ColorBrandBrightGreen300 = "#67fffe";
export const ColorBrandBrightGreen400 = "#33fffd";
export const ColorBrandBrightGreen500 = "#00fffc";
export const ColorBrandBrightGreen600 = "#00ccca";
export const ColorBrandBrightGreen700 = "#009998";
export const ColorBrandBrightGreen800 = "#006665";
export const ColorBrandBrightGreen900 = "#003333";
export const ColorGreen50 = "#e5f9ef";
export const ColorGreen100 = "#ccf2df";
export const ColorGreen200 = "#99e5bf";
export const ColorGreen300 = "#67d9a0";
export const ColorGreen400 = "#34cc80";
export const ColorGreen500 = "#00be5f";
export const ColorGreen600 = "#00984c";
export const ColorGreen700 = "#00733a";
export const ColorGreen800 = "#004d27";
export const ColorGreen900 = "#002613";
export const ColorOrange50 = "#fff5e6";
export const ColorOrange100 = "#ffeacb";
export const ColorOrange200 = "#ffd599";
export const ColorOrange300 = "#ffbf65";
export const ColorOrange400 = "#ffab33";
export const ColorOrange500 = "#ff9500";
export const ColorOrange600 = "#cc7800";
export const ColorOrange700 = "#9a5a00";
export const ColorOrange800 = "#673d00";
export const ColorOrange900 = "#341f00";
export const ColorRed25 = "#fff0f3";
export const ColorRed50 = "#ffe6eb";
export const ColorRed100 = "#ffcdd6";
export const ColorRed200 = "#ff9aac";
export const ColorRed300 = "#ff6681";
export const ColorRed400 = "#ff3357";
export const ColorRed500 = "#ff002d";
export const ColorRed600 = "#cc0024";
export const ColorRed700 = "#99001b";
export const ColorRed800 = "#670013";
export const ColorRed900 = "#330009";
export const ColorGrey50 = "#f3f5f7";
export const ColorGrey100 = "#e6ebed";
export const ColorGrey200 = "#ced7db";
export const ColorGrey300 = "#b4c2c9";
export const ColorGrey400 = "#9baeb7";
export const ColorGrey500 = "#8198a4";
export const ColorGrey600 = "#677a83";
export const ColorGrey700 = "#4e5c64";
export const ColorGrey800 = "#353e43";
export const ColorGrey900 = "#1a1f21";
export const ColorWhite = "#ffffff";
export const ColorBlack = "#000000";
export const ColorPrimary = "#3040b6"; // Alias for color-brand-blue-500
export const ColorPrimaryTint = "#eaecf8"; // Alias for color-brand-blue-50
export const ColorSecondary = "#00fffc"; // Alias for color-brand-bright-green-500
export const ColorSecondaryTint = "#edffff"; // Alias for color-brand-bright-green-75
export const ColorButtonDefaultFill = "#000000";
export const ColorButtonDefaultOutline = "#000000";
export const ColorButtonPrimaryFill = "#ffffff";
export const ColorButtonPrimaryOutline = "#3040b6";
export const ColorButtonSecondaryFill = "#3040b6";
export const ColorButtonSecondaryOutline = "#00fffc";
export const ColorButtonSuccessFill = "#ffffff";
export const ColorButtonSuccessOutline = "#00be5f";
export const ColorButtonWarningFill = "#ffffff";
export const ColorButtonWarningOutline = "#ff9500";
export const ColorButtonDangerFill = "#ffffff";
export const ColorButtonDangerOutline = "#ff002d";
export const ColorButtonWhiteFill = "#3040b6";
export const ColorButtonWhiteOutline = "#ffffff";
export const ColorCardDefault = "#000000";
export const ColorCardInverse = "#ffffff";
export const ColorFormControlDefault = "#000000";
export const ColorFormControlFocus = "#3040b6";
export const ColorFormControlInvalid = "#ff002d";
export const ColorFormControlDisabled = "#677a83";
export const ColorFormControlPlaceholder = "#b4c2c9";
export const ColorRadioLabelDefault = "#000000";
export const ColorRadioLabelInvalid = "#000000";
export const ColorRadioLabelDisabled = "#8198a4";
export const ColorRadioDefault = "#3040b6";
export const ColorRadioInvalid = "#ff002d";
export const ColorRadioDisabled = "#e6ebed";
export const ColorCheckboxLabelDefault = "#000000";
export const ColorCheckboxLabelInvalid = "#000000";
export const ColorCheckboxLabelDisabled = "#8198a4";
export const ColorCheckboxDefault = "#3040b6";
export const ColorCheckboxInvalid = "#ff002d";
export const ColorCheckboxDisabled = "#b4c2c9";
export const BackgroundColorButtonDefaultFill = "#f3f5f7";
export const BackgroundColorButtonDefaultFillHover = "#fbfbfc";
export const BackgroundColorButtonDefaultOutlineRgb = "#ced7db";
export const BackgroundColorButtonDefaultOutlineA = 0.25;
export const BackgroundColorButtonPrimaryFill = "#3040b6";
export const BackgroundColorButtonPrimaryFillHover = "#5966c5";
export const BackgroundColorButtonPrimaryOutlineRgb = "#3040b6";
export const BackgroundColorButtonPrimaryOutlineA = 0.1;
export const BackgroundColorButtonSecondaryFill = "#00fffc";
export const BackgroundColorButtonSecondaryFillHover = "#99fffe";
export const BackgroundColorButtonSecondaryOutlineRgb = "#00fffc";
export const BackgroundColorButtonSecondaryOutlineA = 0.25;
export const BackgroundColorButtonSuccessFill = "#00be5f";
export const BackgroundColorButtonSuccessFillHover = "#34cc80";
export const BackgroundColorButtonSuccessOutlineRgb = "#00be5f";
export const BackgroundColorButtonSuccessOutlineA = 0.1;
export const BackgroundColorButtonWarningFill = "#ff9500";
export const BackgroundColorButtonWarningFillHover = "#ffab33";
export const BackgroundColorButtonWarningOutlineRgb = "#ff9500";
export const BackgroundColorButtonWarningOutlineA = 0.1;
export const BackgroundColorButtonDangerFill = "#ff002d";
export const BackgroundColorButtonDangerFillHover = "#ff3357";
export const BackgroundColorButtonDangerOutlineRgb = "#ff002d";
export const BackgroundColorButtonDangerOutlineA = 0.1;
export const BackgroundColorButtonWhiteFill = "#ffffff";
export const BackgroundColorButtonWhiteFillHover = "#f3f5f7";
export const BackgroundColorButtonWhiteOutlineRgb = "#ffffff";
export const BackgroundColorButtonWhiteOutlineA = 0.25;
export const BackgroundColorFormControlDefault = "#ffffff";
export const BackgroundColorFormControlFocus = "#ffffff";
export const BackgroundColorFormControlInvalid = "#ffffff";
export const BackgroundColorFormControlDisabled = "#f3f5f7";
export const BackgroundColorCheckboxDefault = "#ffffff";
export const BackgroundColorCheckboxInvalid = "#ffffff";
export const BackgroundColorCheckboxDisabled = "#f3f5f7";
export const BackgroundColorCardDefault = "#ffffff";
export const BackgroundColorCardMuted = "#f3f5f7";
export const BackgroundColorCardPrimary = "#3040b6";
export const OpacityButtonDisabled = 0.75;
export const HeightButtonSpinner = "14px";
export const HeightFormControlSmall = "30px";
export const HeightFormControlMedium = "42px";
export const HeightFormControlLarge = "54px";
export const HeightRadio = "28px";
export const HeightCheckbox = "28px";
export const HeightButtonSmall = "30px";
export const HeightButtonMedium = "42px";
export const HeightButtonLarge = "54px";
export const WidthButtonSpinner = "14px";
export const WidthCheckbox = "28px";
export const WidthRadio = "28px";
export const WidthContainerSm = "480px";
export const WidthContainerMd = "760px";
export const WidthContainerLg = "960px";
export const WidthContainerXl = "1200px";
export const PaddingButtonSmall = "12px";
export const PaddingButtonMedium = "16px";
export const PaddingButtonLarge = "20px";
export const PaddingCard = "20px";
export const PaddingFormControlSmall = "8px";
export const PaddingFormControlMedium = "12px";
export const PaddingFormControlLarge = "16px";
export const Margin0 = "0";
export const MarginDefault = "20px";
export const MarginGridGap0 = "0";
export const MarginGridGap10 = "10px";
export const MarginGridGap20 = "20px";
export const MarginGridGap30 = "30px";
export const MarginGridGapDefault = "20px";
export const MarginCardVertical = "20px";
export const MarginCardHorizontal = "0";
export const MarginCardHeader = "20px";
export const MarginCardTitle = "0";
export const SpanGrid10 = "10";
export const SpanGrid12 = "12";
export const TransitionButton = "all 80ms linear";
export const FontFamilyHeading = "'Tablet Gothic Condensed', 'Arial Narrow', Arial, sans-serif";
export const FontFamilyBase = "Fabriga, -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif";
export const FontSizeHeading1 = "70px";
export const FontSizeHeading2 = "54px";
export const FontSizeHeading3 = "40px";
export const FontSizeHeading4 = "32px";
export const FontSizeHeading5 = "24px";
export const FontSizeHeading6 = "20px";
export const FontSizeSubHeading = "24px";
export const FontSizeBody = "16px";
export const FontSizeBodySm = "14px";
export const FontSizeTextSmall = "0.875em";
export const FontSizeTextLarge = "1.125em";
export const FontSizeFormControlSmall = "14px";
export const FontSizeFormControlMedium = "16px";
export const FontSizeFormControlLarge = "18px";
export const FontSizeButtonSmall = "14px";
export const FontSizeButtonMedium = "16px";
export const FontSizeButtonLarge = "18px";
export const FontSizeCardTitle = "20px";
export const FontWeightExtraBold = 800;
export const FontWeightMedium = 500;
export const FontWeightNormal = 400;
export const FontWeightLight = 300;
export const FontWeightHeading = 800;
export const FontWeightBody = 300;
export const FontWeightCardTitle = 500;
export const LineHeightHeading1 = 1;
export const LineHeightHeading2 = 1.1;
export const LineHeightHeading3 = 1.2;
export const LineHeightHeading4 = 1.25;
export const LineHeightHeading5 = 1.3;
export const LineHeightHeading6 = 1.35;
export const LineHeightSubHeading = 1.3;
export const LineHeightBody = 1.4;
export const LineHeightButton = 1;